import { Color, Engine, SceneActivationContext, vec, Vector } from 'excalibur';
import { EventsManager } from '@game-libs/events-manager';
import { DamageSource, GUIActions } from '../types/game-types';
import { GameplayEvents } from '../types/game-events';
import { minutesToMillisec } from '@game-libs/exc-libs/src/helpers/math.helper';
import { DragonShadow } from './dragonShadow';
import { BaseLevel } from './baseLevel';
import { LittleDragon } from './littleDragon';
import { BigDragon } from './bigDragon';

export class TutorialLevel extends BaseLevel {
  // private enemy: BigDragon = new BigDragon();
  private enemy: LittleDragon = new LittleDragon();

  // Dragon-specific event listener unsubscribe functions
  private unsubBiggerDragon?: () => void;
  private unsubDamageDragon?: () => void;
  private unsubWinGame?: () => void;
  private unsubDadDragonReveal?: () => void;

  private roarInterval?: ReturnType<typeof setInterval>;

  public getDragonPosition(offset = vec(0, 0)): Vector {
    return this.getAttackTargetPosition(offset);
  }

  protected onLevelInitialize(engine: Engine): void {
    const { on, emit } = EventsManager();
    let dragonShadow: DragonShadow;

    this.unsubBiggerDragon = on('bigger_dragon', () => {
      dragonShadow = new DragonShadow();
      this.add(dragonShadow);
    });

    this.unsubDadDragonReveal = on('dad_dragon_reveal', () => {
      console.log('dad_dragon_reveal');
      const bigDragon = new BigDragon();
      bigDragon.pos = this.getDragonPosition();
      this.add(bigDragon);
      dragonShadow?.kill();
    });

    this.enemy.pos = this.getDragonPosition();
    this.add(this.enemy);

    this.roarInterval = setInterval(() => {
      emit(GameplayEvents.DRAGON_GRUNT);
    }, minutesToMillisec(3));

    this.unsubDamageDragon = on(GameplayEvents.DAMAGE_DRAGON, ({ source }: { source: DamageSource }) => {
      if (source === DamageSource.Click) {
        this.shake.addTrauma(0.5);
      }
    });

    this.unsubWinGame = on(GUIActions.WIN_GAME, () => {
      this.enemy.startDeathSequence();
      if (this.roarInterval) {
        clearInterval(this.roarInterval);
      }
    });
  }

  protected override onLightningAttackHit(): void {
    this.enemy.dragon.actions.blink(20, 10, 10);
  }

  protected onPoisonAttackHit(): void {
    this.enemy.dragon.actions.callMethod(() => {
      if (this.enemy.dragon.graphics.current) {
        this.enemy.dragon.graphics.current.tint = Color.fromHex('99FF99');
      }
    }).delay(200).callMethod(() => {
      const graphicsNames = this.enemy.dragon.graphics.getNames();
      graphicsNames.forEach((name) => {
        const graphic = this.enemy.dragon.graphics.getGraphic(name);
        if (graphic) {
          graphic.tint = Color.White;
        }
      });
    });
  }

  protected onLevelDeactivate(ctx: SceneActivationContext): void {
    // Unsubscribe from dragon-specific event listeners
    this.unsubBiggerDragon?.();
    this.unsubDadDragonReveal?.();
    this.unsubDamageDragon?.();
    this.unsubWinGame?.();

    // Cleanup enemy subscriptions
    this.enemy.cleanup();

    if (this.roarInterval) {
      clearInterval(this.roarInterval);
    }
  }
}
